/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class oxygentestresults extends IceEntity {
  oxygen_test_results_key: string = "";
  oxygen_test_results_code: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  gettablename(): string {
    return "OXYGEN_TEST_RESULTS";
  }
}
